/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type Image, ImageSchema } from './image'

/* TypeScript */
export type DiscountBannerApiProps = {
  technicalName?: Maybe<string>
  discountType: 'military' | 'student'
  title: string
  description?: Maybe<string>
  ctaLabel: string
  secondaryCtaLabel?: Maybe<string>
  image: Image
}

/* Schemas */
export const DiscountBannerApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  discountType: z.enum(['military', 'student']),
  title: z.string(),
  description: z.nullish(z.string()),
  ctaLabel: z.string(),
  secondaryCtaLabel: z.nullish(z.string()),
  image: ImageSchema,
})

/* Schemas validation */
type TestDiscountBannerProps = ExpectTrue<
  Equal<DiscountBannerApiProps, z.infer<typeof DiscountBannerApiPropsSchema>>
>
